import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// The public site is English-only. All page text is hardcoded in components
// (via the static useTranslations hook), so react-i18next is kept only for
// legacy components that still call useTranslation(); it serves no resources.
i18n
  .use(initReactI18next)
  .init({
    resources: {},
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
